// extracted by mini-css-extract-plugin
export default {"page":"IssuesPage_page__XnMxa"};